import {
    Component,
    OnInit,
    Input
} from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { HistoryDataSource } from '../history/history.data-source';

@Component({
    selector: 'app-market-table-history',
    templateUrl: './table-history.component.pug',
    styleUrls: ['./table-history.component.less']
})
export class TableHistoryComponent implements OnInit {
    @Input() dataSource: HistoryDataSource;

    public expandedAll = false;

    private _columnsSbj = new BehaviorSubject<string[]>([
        'date', 'shard', 'tick', 'change', 'balance', 'description', 'actions'
    ]);

    public columns$ = this._columnsSbj.asObservable();

    constructor(
    ) {
    }

    ngOnInit() {
    }

    expandAll() {
        this.expandedAll = true;
    }

    collapseAll() {
        this.expandedAll = false;
    }

    onExpand(data, next) {
        next();
    }
}
